import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

/**
 * Floating action button for AI courtyard support.
 * Fixed bottom-right position with courtyard-themed styling.
 * Links to /courtyard (placeholder for future AI chat integration).
 */
const FloatingCourtyardButton = () => {
  const location = useLocation();

  // Hide on the courtyard page itself
  if (location.pathname === '/courtyard') return null;

  return (
    <Link
      to="/courtyard"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Return to the Courtyard"
    >
      <div className="relative">
        {/* Pulse animation ring */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-courtyard-terracotta to-courtyard-gold opacity-40 animate-ping" />

        {/* Button */}
        <div
          className={
            'relative w-14 h-14 rounded-full ' +
            'bg-gradient-to-br from-courtyard-clay to-courtyard-terracotta-dark ' +
            'shadow-lg hover:shadow-xl ' +
            'flex items-center justify-center ' +
            'transition-all duration-300 ' +
            'hover:scale-110 active:scale-95'
          }
        >
          <MessageCircle className="w-6 h-6 text-white" aria-hidden="true" />
        </div>

        {/* Tooltip */}
        <div
          className={
            'absolute bottom-full right-0 mb-3 px-3 py-1.5 ' +
            'bg-courtyard-stone text-white text-xs font-medium ' +
            'rounded-lg whitespace-nowrap ' +
            'opacity-0 group-hover:opacity-100 ' +
            'transition-opacity duration-200 ' +
            'pointer-events-none'
          }
        >
          Return to the Courtyard
          <div className="absolute top-full right-5 w-2 h-2 bg-courtyard-stone rotate-45 -mt-1" />
        </div>
      </div>
    </Link>
  );
};

export default FloatingCourtyardButton;
